export default __webpack_public_path__ + "static/SRF 1140S - Product Specifications & Technical Data-500a5725e3c6c99fdcdc4322a9ab63c0.pdf";